export const QUESTION_AGE = 'age';
export const QUESTION_RETIREMENT_AGE = 'retirement_age';
export const QUESTION_MONTHLY_CONTRIBUTION = 'monthly_contribution';
export const QUESTON_PENSION_POT = 'pension_pot';
export const QUESTION_RETIREMENT_INCOME = 'retirement_income';
